import { Prepack } from 'graphql-api/gql-api-interfaces';

import {
  DeliveryItem,
  DeliveryItemsByShop,
  PrePackType,
  ShopDeliveryItemTotals,
} from '../../models';

import { countPrepackItems } from './count-prepack-items';

export function countItemsTotals(
  sellables: { [productId: string]: DeliveryItem },
  prepacks: Partial<PrePackType>[],
  quantityKey: 'quantity' | 'usedTrueDemandQuantity' = 'quantity',
) {
  return Object.entries(sellables).reduce((sum, [productId, deliveryItem]) => {
    const quantity = deliveryItem[quantityKey];
    const prepack = prepacks.find((entry) => entry.productId === productId);
    return sum + (prepack ? countPrepackItems(prepack, quantity) : quantity);
  }, 0);
}

const countItemsShopTotals =
  (quantityKey: 'quantity' | 'usedTrueDemandQuantity' = 'quantity') =>
  (
    prepacks: Partial<PrePackType>[],
    deliveryItems: DeliveryItemsByShop,
  ): ShopDeliveryItemTotals => {
    return Object.keys(deliveryItems).reduce((shopsTotals, shopId) => {
      shopsTotals[shopId] = Object.keys(deliveryItems[shopId]).reduce(
        (acc, current) => {
          return (
            acc +
            countItemsTotals(
              deliveryItems[shopId][current].items,
              prepacks as Partial<Prepack>[],
              quantityKey,
            )
          );
        },
        0,
      );
      return shopsTotals;
    }, {} as ShopDeliveryItemTotals);
  };

export const countShopDeliveryItemTotals = countItemsShopTotals('quantity');
export const countShopDeliveryItemTrueDemandTotals = countItemsShopTotals(
  'usedTrueDemandQuantity',
);
